import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export const categorySearchAtom = atom<{ [k: string]: string }>({});

export const editSubscriptionAtom = atomWithReset<{
  emailId: string | null;
}>({ emailId: null });

export const createSubscriptionAtom = atomWithReset(false);

export const isEditCreateFormOpenAtom = atom((get) => {
  const editId = get(editSubscriptionAtom).emailId;
  const createFlag = get(createSubscriptionAtom);

  return !!editId || createFlag;
});

export const emailsToUnsubscribeAtom = atomWithReset<string[]>([]);
